<template>
    <div class="pa-5" v-if="activeTag">
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "ID" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeTag.id ? activeTag.id : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Name" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeTag.name ? activeTag.name : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Description" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeTag.description ? activeTag.description : "-" }}
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "general-tab",
    data() {
        return {};
    },
    computed: {
        ...mapState("TagStore", ["activeTag"])
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}

.col-item {
    padding-top: 2px;
    padding-bottom: 2px;
}
</style>
